import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';
import ToggleSwitch from '@ui/inputs/ToggleSwitch.tsx';
import Tooltip from '@ui/tooltip';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';
import { RouteType, RouteOptionsClassification } from '../constants.ts';

const RouteTypeSwitchLabel = styled.span`
  display: inline-block;
  margin-inline-start: 0.5em;
`;

const ToggleSwitchWrapper = styled.div`
  margin-inline-start: 12px;
`;

const TightTooltip = styled(Tooltip)`
  width: fit-content;
`;

const WheelchairAccessibilityToggle = ({
  ref,
  routeTypes,
  routeAccessibiltyChoice,
  onSwitchRouteTypeButtonClicked,
  T,
}) => {
  const colors = useCSSColors();
  return (
    <TightTooltip text={T('getDirectionsFromTo:Wheelchair accessible')} arrowPosition={'left'}>
      <ToggleSwitchWrapper>
        <ToggleSwitch
          ref={ref}
          onSwitch={s => onSwitchRouteTypeButtonClicked(s ? RouteType.ACCESSIBLE : RouteType.DIRECT)}
          datacy="RouteTypeToggleSwitch"
          checked={routeAccessibiltyChoice === RouteType.ACCESSIBLE}
          ariaLabel={T('getDirectionsFromTo:Wheelchair accessible')}
          label={
            <RouteTypeSwitchLabel id="wheelchair-accessible-label">
              <Icon className="icon" width={24} height={24} name="accessible" cdn fillColor={colors.widgetIconFill} />
            </RouteTypeSwitchLabel>
          }
          disabled={
            routeTypes === RouteOptionsClassification.NO_ACCESSIBLE_ROUTES ||
            routeTypes === RouteOptionsClassification.DEFAULT_IS_ACCESSIBLE
          }
        />
      </ToggleSwitchWrapper>
    </TightTooltip>
  );
};

export default WheelchairAccessibilityToggle;
